import fs from 'node:fs';
import path from 'node:path';

/** Canonical absolute path for stable SQLite parent keys (resolves /private/var vs /var on macOS). */
export function normalizeResolvedPath(resolved: string): string {
  const abs = path.resolve(resolved);
  try {
    return fs.realpathSync.native(abs);
  } catch {
    return abs;
  }
}
